// extracted by mini-css-extract-plugin
module.exports = {"ratingsText":"HeroRatings_ratingsText__xqn5x","ratingsImage":"HeroRatings_ratingsImage__0bh0F"};